module.exports = __webpack_public_path__ + "static/img/lianjie.dcbe94f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/lianjie.png
// module id = 5zjH
// module chunks = 0